import React from 'react';
import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';
import { ArrowRight } from 'pcln-icons';
import { Box, Card, Flex, Link, Text } from 'pcln-design-system';
const MEDIA_SIZE = 84;
const FlexCard = /*#__PURE__*/styled(Card).withConfig({
  displayName: "TripSummaryCard__FlexCard",
  componentId: "sc-121snix-0"
})(["display:flex;flex-direction:column;align-items:center;gap:12px;border:none;box-shadow:", ";cursor:", ";", "{flex-direction:row;}&:hover{box-shadow:", ";}"], themeGet('shadows.sm'), props => props.onClick ? 'pointer' : 'default', themeGet('mediaQueries.md'), props => props.onClick && themeGet(`shadows.${props.hoverBoxShadowSize || 'xl'}`));
const Heading = /*#__PURE__*/styled(Text).withConfig({
  displayName: "TripSummaryCard__Heading",
  componentId: "sc-121snix-1"
})(["", ""], props => props.truncateHeading && `
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  `);
/** @public */
function TripSummaryCard({
  className,
  actionText,
  caption,
  body,
  heading,
  handleSubmitCTA,
  onClick,
  hoverBoxShadowSize,
  truncateHeading,
  showArrowRight,
  mediaNode,
  mediaNodeBackgroundColor = 'transparent',
  noTranslateHeading = false,
  noTranslateCaption = false,
  buttonNode
}) {
  const translateHeadingConfig = noTranslateHeading ? {
    translate: 'no'
  } : {};
  const translateCaptionConfig = noTranslateCaption ? {
    translate: 'no'
  } : {};
  function handleKeyDown(e) {
    if (handleSubmitCTA && e.key === 'Enter') {
      handleSubmitCTA(e);
    }
  }
  function handleOnClick(e) {
    e.stopPropagation();
    onClick?.(e);
  }
  return React.createElement(FlexCard, {
    "data-testid": 'trip-summary-card',
    borderRadius: 'xl',
    className: className,
    color: 'background.lightest',
    hoverBoxShadowSize: hoverBoxShadowSize,
    height: '100%',
    minHeight: MEDIA_SIZE,
    p: 2,
    role: onClick || handleSubmitCTA ? 'link' : '',
    tabIndex: onClick || handleSubmitCTA ? '0' : '-1',
    onClick: handleOnClick,
    onKeyDown: handleKeyDown
  }, React.createElement(Flex, {
    width: 1,
    minWidth: 0
  }, mediaNode && React.createElement(Box, {
    style: {
      alignSelf: 'stretch'
    }
  }, React.createElement(Flex, {
    borderRadius: 'md',
    color: mediaNodeBackgroundColor,
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: MEDIA_SIZE,
    maxWidth: MEDIA_SIZE,
    height: '100%',
    minHeight: MEDIA_SIZE,
    mr: 1
  }, mediaNode)), React.createElement(Flex, {
    justifyContent: 'space-between',
    alignItems: 'center',
    width: 1,
    minWidth: 0
  }, React.createElement(Flex, {
    flexDirection: 'column',
    mx: 2,
    minWidth: 0
  }, React.createElement(Heading, {
    mt: 1,
    fontWeight: 'bold',
    textStyle: 'heading5',
    truncateHeading: truncateHeading,
    ...translateHeadingConfig
  }, heading), caption && React.createElement(Text, {
    mt: 1,
    textStyle: 'paragraph',
    ...translateCaptionConfig
  }, caption), body && React.createElement(Box, {
    width: 1,
    mt: 1
  }, body), actionText && React.createElement(Link, {
    onClick: handleOnClick,
    mt: 1
  }, React.createElement(Flex, {
    alignItems: 'center'
  }, React.createElement(Text, {
    textStyle: 'paragraphBold'
  }, actionText)))), onClick && showArrowRight && React.createElement(ArrowRight, {
    color: 'primary',
    size: 20,
    title: 'ArrowRight'
  }))), buttonNode);
}
export default TripSummaryCard;